import React, { lazy, Suspense } from 'react'
import { useParams } from 'react-router-dom'
import { CombinedFormDetailsAzure } from '../../components/ViewCombinedForm'

const CombinedFormDetailsAWS = lazy(() =>
  import('../../components/CombinedForm').then(module => ({
    default: module.CombinedFormDetailsAWS,
  }))
)

export const DetailsView: React.FC = () => {
  const { cloud } = useParams<{ cloud: string }>()

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {cloud === 'aws' && <CombinedFormDetailsAWS isImpartner={true} />}
      {(cloud === 'azure' || cloud === 'AZURE') && <CombinedFormDetailsAzure />}
    </Suspense>
  )
}
